import PrimeRmsContainer from "./PrimeRmsContainer";
import PrimeRmsStore from "./PrimeRmsStore";

export default PrimeRmsStore(PrimeRmsContainer);
